import { getLeagueLogoUrl } from '../../urls';
import { LEAGUE_NAMES, type ESPNLeagueId } from '../../../shared';
import { LIGHT, bbox, leagueBuilder, team } from '../builders';
import type { LogoVsLogoLeague } from '../types';

const ID: ESPNLeagueId = 'bundesliga';
const { uniform, variant } = leagueBuilder(ID);

const teams = [
  team('augsburg', 'Augsburg', uniform('augsburg', '#D33837', '#5B8358')),
  team('bayern', 'Bayern München', uniform('bayern', '#DC052D', LIGHT)),
  team('bremen', 'Werder Bremen', uniform('bremen', '#009750', LIGHT)),
  team('dortmund', 'Borussia Dortmund', uniform('dortmund', '#FFE500', '#000000')),
  team('frankfurt', 'Eintracht Frankfurt', uniform('frankfurt', '#FF0007', LIGHT)),
  team('freiburg', 'SC Freiburg', uniform('freiburg', '#000000', LIGHT)),
  team('gladbach', 'Borussia Mönchengladbach', uniform('gladbach', '#000000', LIGHT)),
  team('hamburg', 'Hamburger SV', [variant('#1E5CB3', 'hamburg')]),
  team('heidenheim', 'FC Heidenheim', uniform('heidenheim', '#003E7B', '#BF0411')),
  team('hoffenheim', 'TSG Hoffenheim', uniform('hoffenheim', '#125DAA', LIGHT)),
  team('koln', '1. FC Köln', [variant('#E41E26', 'koln')]),
  team('leipzig', 'RB Leipzig', uniform('leipzig', '#FF0023', LIGHT)),
  team('leverkusen', 'Bayer Leverkusen', uniform('leverkusen', '#FF2F34', '#2F3133')),
  team('mainz', '1. FSV Mainz 05', uniform('mainz', '#E40C18', LIGHT)),
  team('st-pauli', 'FC St. Pauli', uniform('st-pauli', ['#FF010B', '#FF010C'], LIGHT)),
  team('stuttgart', 'VfB Stuttgart', uniform('stuttgart', '#F60025', LIGHT)),
  team('union-berlin', '1. FC Union Berlin', uniform('union-berlin', '#FF161F', LIGHT)),
  team('wolfsburg', 'VfL Wolfsburg', uniform('wolfsburg', LIGHT, '#000000')),
  team('bochum', 'Bochum', uniform('bochum', '#2D4F9E', LIGHT)),
  team('schalke', 'Schalke 04', uniform('schalke', '#004B9C', '#DDDDDD')),
  team('holstein-kiel', 'Holstein Kiel', uniform('holstein-kiel', '#0056A0', '#FF1236')),
  team('paderborn', 'Paderborn', uniform('paderborn', LIGHT, '#000000')),
  team('elversberg', 'Elversberg', uniform('elversberg', '#DABF8B', '#000000'))
];

export const bundesliga: LogoVsLogoLeague = {
  value: ID,
  label: LEAGUE_NAMES[ID],
  logo: { src: getLeagueLogoUrl(ID), bbox: bbox(34, 43, 297, 297) },
  teams
};
